import { Drawer, Avatar, Divider, Button, Result } from "antd";
import { useState } from "react";
import axiosInstance from "../../config/axios-instance";
import LazyImg from "./LazyImage";

const LibraryDrawer = ({
  onClose,
  visible,
  item,
  elasticity,
  fibers,
  colors,
  washes,
  weights,
  refetch,
}: any) => {
  const [data, setData] = useState<any>();
  const [isVisible, setIsVisible] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);

  const handleChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const submit = (e: any) => {
    e.preventDefault();
    let token = localStorage.getItem("token");
    setUpdateLoading(true);
    return axiosInstance({
      method: "post",
      url: `/admin/fabrics/${item.id}`,
      data: { ...data, _method: "patch" },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(async () => {
        setUpdateLoading(false);
        await refetch();
        onClose();
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Drawer
        title={`Edit ${item?.name}`}
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        width="510"
        mask
        maskClosable={false}
      >
        {item && (
          <>
            <div className="d-flex justify-content-center flex-column align-items-center mt-4">
              {/* <Avatar
                src={process.env.REACT_APP_STORAGE_URL + item.image}
                size={200}
                shape="square"
                style={{
                  boxShadow: "2px 0px 5px rgba(0,0,0,0.2)",
                  borderRadius: 5,
                }}
              /> */}
              {item.images.length !== 0 ? (
                item.images.map((el: any) => (
                  <LazyImg
                    alt={el.fabric_id}
                    src={
                      el.image
                        ? process.env.REACT_APP_STORAGE_URL + el.image
                        : null
                    }
                    thumb={
                      el.image
                        ? process.env.REACT_APP_STORAGE_URL + el.image
                        : null
                    }
                    style={{
                      objectFit: "cover",
                      borderRadius: 0,
                      height: 263 / item.images.length + "px",
                      width: "50%",
                    }}
                  />
                ))
              ) : (
                <LazyImg
                  alt={item.name}
                  src={
                    item.image
                      ? process.env.REACT_APP_STORAGE_URL + item.image
                      : null
                  }
                  thumb={
                    item.image
                      ? process.env.REACT_APP_STORAGE_URL + item.image
                      : null
                  }
                  style={{ objectFit: "cover", height: "263px" }}
                />
              )}
            </div>
            <Divider />
            <form
              className="d-flex flex-column px-5"
              style={{ position: "relative", paddingBottom: 90 }}
            >
              <div className="d-flex flex-column">
                <label style={{ fontWeight: 600 }}>Fabric Name</label>
                <input
                  type="text"
                  className="input-items-update"
                  required
                  defaultValue={item.name}
                  name="name"
                  onChange={handleChange}
                />
              </div>
              <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Fabric Type</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item.fabric}
                  name="fabric"
                  onChange={handleChange}
                />
              </div>
              {/* {item.fabric_type === "denim" && (
                <div className="d-flex flex-column my-2">
                  <label style={{ fontWeight: 600 }}>Wash</label>
                  <select
                    className="input-items-update"
                    defaultValue={item.wash.id}
                    name="wash_id"
                    onChange={handleChange}
                  >
                    <option disabled value="">
                      Select wash
                    </option>
                    {washes.map((el: any) => (
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    ))}
                  </select>
                </div>
              )} */}
              <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Color</label>
                <select
                  className="input-items-update"
                  defaultValue={item.color.id}
                  name="color_id"
                  onChange={handleChange}
                >
                  <option disabled value="">
                    Select color
                  </option>
                  {colors
                    .filter(
                      (color: any) => color.fabric_type === item.fabric_type
                    )
                    .map((el: any) => (
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Composition</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item?.composition_value}
                  name="composition_value"
                  onChange={handleChange}
                />
              </div>
              {item.fabric_type === "denim" && (
                <>
                  <div className="d-flex flex-column my-2">
                    <label style={{ fontWeight: 600 }}>Elasticity (%)</label>
                    <input
                      type="number"
                      name="elasticity_value"
                      onChange={handleChange}
                      defaultValue={item.elasticity_value}
                      className="input-items-update"
                      min="0"
                      max="100"
                    />
                  </div>
                  {/* <div className="d-flex flex-column my-2">
                    <label style={{ fontWeight: 600 }}>Fiber</label>
                    <select
                      className="input-items-update"
                      defaultValue={item.fiber.id}
                      name="fiber_id"
                      onChange={handleChange}
                    >
                      <option disabled value="">
                        Select fiber
                      </option>
                      {fibers.map((fiber: any) => (
                        <option key={fiber.id} value={fiber.id}>
                          {fiber.name}
                        </option>
                      ))}
                    </select>
                  </div> */}
                </>
              )}
              <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Weight</label>
                <input
                  type="text"
                  name="weight_value"
                  onChange={handleChange}
                  defaultValue={item.weight_value}
                  className="input-items-update"
                />
              </div>
              {/* <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Weight before wash</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item.weight_before}
                  name="weight_before"
                  onChange={handleChange}
                />
              </div> */}
              {/* <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Weight after wash</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item.weight_after}
                  name="weight_after"
                  onChange={handleChange}
                />
              </div> */}
              {item.fabric_type === "denim" && (
                <>
                  <div className="d-flex flex-column my-2">
                    <label style={{ fontWeight: 600 }}>
                      Shrinkage warp max
                    </label>
                    <input
                      type="text"
                      className="input-items-update"
                      defaultValue={item.retrait_warp_max}
                      name="retrait_warp_max"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="d-flex flex-column my-2">
                    <label style={{ fontWeight: 600 }}>
                      Shrinkage weft max
                    </label>
                    <input
                      type="text"
                      className="input-items-update"
                      defaultValue={item.retrait_weft_max}
                      name="retrait_weft_max"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="d-flex flex-column my-2">
                    <label style={{ fontWeight: 600 }}>Growth</label>
                    <input
                      type="text"
                      className="input-items-update"
                      defaultValue={item.growth}
                      name="growth"
                      onChange={handleChange}
                    />
                  </div>
                </>
              )}
              {/* <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Tearing wrap min</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item.tearing_wrap_min}
                  name="tearing_wrap_min"
                  onChange={handleChange}
                />
              </div>
              <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Tearing weft min</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item.tearing_weft_min}
                  name="tearing_weft_min"
                  onChange={handleChange}
                />
              </div>
              <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Tearing weft</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item.tearing_weft}
                  name="tearing_weft"
                  onChange={handleChange}
                />
              </div>
              <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Tearing wrap</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item.tearing_wrap}
                  name="tearing_wrap"
                  onChange={handleChange}
                />
              </div>
              <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Tearing wrap rate</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item.tearing_wrap_rate}
                  name="tearing_wrap_rate"
                  onChange={handleChange}
                />
              </div> */}
              {/* <div className="d-flex flex-column my-2">
                <label style={{ fontWeight: 600 }}>Meters in stock</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item.meters_in_stock}
                  name="meters_in_stock"
                  onChange={handleChange}
                />
              </div> */}
              <div className="d-flex flex-column my-2 mb-5">
                <label style={{ fontWeight: 600 }}>Supplier</label>
                <input
                  type="text"
                  className="input-items-update"
                  defaultValue={item.supplier}
                  name="supplier"
                  onChange={handleChange}
                />
              </div>
              <footer
                className="library-drawer-footer d-flex justify-content-center pl-0 border-top mt-3 py-3 position-abosulte bg-white"
                style={{ position: "fixed", bottom: "0", width: "420px" }}
              >
                <Button
                  type="default"
                  className="cancel_btn"
                  onClick={() => (data ? setIsVisible(true) : onClose())}
                >
                  Cancel
                </Button>
                <Button
                  type="default"
                  className="approve_btn"
                  loading={updateLoading}
                  onClick={submit}
                >
                  Save
                </Button>
                {/* <button
                  type="submit"
                  className="mr-2 submit_button_blue cancel_drawer_btn px-0 py-1"
                  style={{ fontSize: "20px", width: "200px" }}
                  onClick={submit}
                >
                  {updateLoading ? "Saving..." : "Save"}
                </button> */}
                {/* <button
                  type="button"
                  className="px-0 py-1 submit_button_white cancel_drawer_btn"
                  style={{ fontSize: "20px", width: "200px" }}
                  onClick={() => (data ? setIsVisible(true) : onClose())}
                >
                  Cancel
                </button> */}
              </footer>
            </form>
          </>
        )}
      </Drawer>
      <Drawer
        placement="right"
        closable={false}
        onClose={onClose}
        visible={isVisible}
        width="510"
        mask
        maskClosable={false}
        className="cancel-update-drawer"
      >
        <Result
          status="warning"
          title="You have made some changes to this item, are you sure you want to cancel these changes ?"
          extra={[
            <Button
              type="primary"
              onClick={() => {
                setIsVisible(false);
                onClose();
              }}
              style={{
                borderRadius: 5,
                background: "#00468c",
                borderColor: "#00468c",
              }}
              className="px-5"
            >
              Yes
            </Button>,
            <Button
              type="ghost"
              onClick={() => setIsVisible(false)}
              style={{ borderRadius: 5 }}
              className="px-5"
            >
              No
            </Button>,
          ]}
        />
      </Drawer>
    </>
  );
};

export default LibraryDrawer;
